<template>
  <v-container style="max-width: 1000px">
    <v-layout wrap>
      <v-flex xs9>
        <h3 class="headline">{{ $t('Additional messages after order summary') }}</h3>
      </v-flex>
      <v-flex xs3 class="text-xs-right">
        <template v-if="$store.getters.getPackage == 'premium'">
          <v-btn
            fab
            outline
            small
            color="primary"
            v-if="!isEditMessage"
            @click="isEditMessage = true"
          >
            <em class="fa fa-pencil-alt middle" />
          </v-btn>
        </template>
        <template v-else>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn readonly fab outline small color="grey" v-on="on">
                <v-icon>lock</v-icon>
              </v-btn>
            </template>
            <span>{{ $t('Upgrade to Premium Plan') }}</span>
          </v-tooltip>
        </template>
      </v-flex>
    </v-layout>

    <div v-if="wordafter.loading">
      <div class="text-xs-center">
        <v-progress-circular indeterminate color="primary"></v-progress-circular>
      </div>
    </div>

    <v-layout wrap v-else>
      <v-flex xs12 sm6 class="border-right pa-1">
        <view-cart-summary-viewer></view-cart-summary-viewer>

        <template v-if="isEditMessage">
          <div
            class="message"
            style="
              float: left;
              position: relative;
              border-radius: 12px;
              max-width: 281px;
              overflow-wrap: break-word;
              min-height: 22px;
              min-width: 14px;
              line-height: 15.36px;
              overflow: hidden;
              cursor: pointer;
            "
          >
            <div style="font-size: 12px; color: black">
              <template>
                <div style="padding: 8px 6px 2px; background-color: #f1f0f0">
                  <div
                    class="form-control"
                    :class="{ 'has-error': errors.has('answer_word_cart_summary') }"
                  >
                    <autoresize-textarea
                      maxlength="640"
                      ref="answer_word_cart_summary"
                      class
                      :placeholder="$t('Chatbot answers')"
                      v-model="wordafter.wordscartsummary.text"
                      name="answer"
                      data-vv-as="Answer"
                      :data-vv-name="'answer_word_cart_summary'"
                      v-validate
                      style="resize: none; display: inherit; margin-bottom: 5px"
                    ></autoresize-textarea>

                    <span class="text-error" v-show="errors.has('answer_word_cart_summary')">{{
                      errors.first('answer_word_cart_summary')
                    }}</span>
                  </div>
                </div>
              </template>
            </div>

            <div class="clearfix"></div>
          </div>

          <intent-prefill
            @addIntentPrefill="addWordCartSummaryPrefill($event)"
            :payment="true"
          ></intent-prefill>
        </template>
        <template v-else>
          <div
            class="message"
            v-if="
              wordafter.wordscartsummary.text != '' && wordafter.wordscartsummary.type == 'text'
            "
            style="
              float: left;
              position: relative;
              border-radius: 12px;
              max-width: 181px;
              overflow-wrap: break-word;
              min-height: 22px;
              min-width: 14px;
              line-height: 15.36px;
              overflow: hidden;
              margin-bottom: 5px;
            "
          >
            <div style="font-size: 12px" :style="{ color: 'black' }">
              <div style="padding: 5px 8px 6px" :style="{ 'background-color': '#F1F0F0' }">
                <span style="line-height: 15.36px; line-height: 22px">
                  <template v-if="wordafter.wordscartsummary.text != ''">
                    <specialtext :text="wordafter.wordscartsummary.text"></specialtext>
                  </template>
                </span>
              </div>
            </div>
          </div>
        </template>
        <v-divider class="hidden-sm-and-up"></v-divider>
      </v-flex>
      <v-flex xs12 sm6 class="pa-1">
        <view-receipt-viewer></view-receipt-viewer>
        <template v-if="isEditMessage">
          <div
            class="message"
            style="
              float: left;
              position: relative;
              border-radius: 12px;
              max-width: 281px;
              overflow-wrap: break-word;
              min-height: 22px;
              min-width: 14px;
              line-height: 15.36px;
              overflow: hidden;
              cursor: pointer;
            "
          >
            <div style="font-size: 12px; color: black">
              <template>
                <div style="padding: 8px 6px 2px; background-color: #f1f0f0">
                  <div
                    class="form-control"
                    :class="{ 'has-error': errors.has('answer_word_orders') }"
                  >
                    <autoresize-textarea
                      maxlength="640"
                      ref="answer_word_orders"
                      class
                      :placeholder="$t('Chatbot answers')"
                      v-model="wordafter.wordsorders.text"
                      name="answer"
                      data-vv-as="Answer"
                      :data-vv-name="'answer_word_orders'"
                      v-validate
                      style="resize: none; display: inherit; margin-bottom: 5px"
                    ></autoresize-textarea>

                    <span class="text-error" v-show="errors.has('answer_word_orders')">{{
                      errors.first('answer_word_orders')
                    }}</span>
                  </div>
                </div>
              </template>
            </div>

            <div class="clearfix"></div>
          </div>
        </template>
        <template v-else>
          <div
            class="message"
            v-if="wordafter.wordsorders.text != '' && wordafter.wordsorders.type == 'text'"
            style="
              float: left;
              position: relative;
              border-radius: 12px;
              max-width: 181px;
              overflow-wrap: break-word;
              min-height: 22px;
              min-width: 14px;
              line-height: 15.36px;
              overflow: hidden;
              margin-bottom: 5px;
            "
          >
            <div style="font-size: 12px" :style="{ color: 'black' }">
              <div style="padding: 5px 8px 6px" :style="{ 'background-color': '#F1F0F0' }">
                <span style="line-height: 15.36px; line-height: 22px">
                  <template v-if="wordafter.wordsorders.text != ''">
                    <specialtext :text="wordafter.wordsorders.text"></specialtext>
                  </template>
                </span>
              </div>
            </div>
          </div>
        </template>
      </v-flex>
    </v-layout>

    <PaymentFollowupContainerAfterSummary v-model="wordafter" :isEdit="isEditMessage" />

    <div class="text-xs-center" v-if="isEditMessage">
      <v-btn outline color="grey" @click="cancelEditWordAfterOrderAndCartSummary">{{
        $t('cancel')
      }}</v-btn>
      <v-btn depressed color="primary" @click="saveWordAfterOrderAndCartSummary">{{
        $t('Save')
      }}</v-btn>
    </div>
  </v-container>
</template>

<script>
import ViewCartSummaryViewer from '@/components/elements/ViewCartSummaryViewer'
import ViewReceiptViewer from '@/components/elements/ViewReceiptViewer'
import specialtext from '@/components/elements/specialtext'
import IntentPrefill from '@/components/view/intent/IntentPrefill'
import AutoresizeTextarea from '@/components/elements/AutoresizeTextarea'
import { mapGetters } from 'vuex'
import api from '@/api'
import PaymentFollowupContainerAfterSummary from './PaymentFollowupContainerAfterSummary'
export default {
  data() {
    return {
      isEditMessage: false,
      wordafter: {
        loading: true,
        wordscartsummary: {
          type: 'text',
          text: ''
        },
        wordsorders: {
          type: 'text',
          text: ''
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      currentLang: 'currentLang'
    })
  },
  mounted() {
    this.getWordAfterOrderAndCartSummary()
  },
  components: {
    ViewCartSummaryViewer,
    ViewReceiptViewer,
    specialtext,
    IntentPrefill,
    AutoresizeTextarea,
    PaymentFollowupContainerAfterSummary
  },
  methods: {
    addWordCartSummaryPrefill(prefill) {
      var vm = this
      let cursorPosition = vm.$refs.answer_word_cart_summary.$el.selectionStart

      vm.wordafter.wordscartsummary.text = [
        vm.wordafter.wordscartsummary.text.slice(0, cursorPosition),
        '{' + prefill + '}',
        vm.wordafter.wordscartsummary.text.slice(cursorPosition)
      ].join('')
    },
    cancelEditWordAfterOrderAndCartSummary() {
      var vm = this
      vm.wordafter.wordscartsummary = JSON.parse(vm.cached_wordscartsummary)
      vm.wordafter.wordsorders = JSON.parse(vm.cached_wordsorders)
      vm.wordafter = JSON.parse(vm.cached_wordafter)
      vm.isEditMessage = false
      vm.wordafter.loading = false
    },
    saveWordAfterOrderAndCartSummary() {
      var vm = this

      if (vm.wordafter.follow_up_cart.delay_time) {
        vm.wordafter.follow_up_cart_within_seconds = {
          HH: '00',
          mm: '00'
        }
        vm.wordafter.follow_up_cart_within_seconds.HH = vm.wordafter.follow_up_cart.delay_time.HH
          ? vm.wordafter.follow_up_cart.delay_time.HH
          : '00'
        vm.wordafter.follow_up_cart_within_seconds.mm = vm.wordafter.follow_up_cart.delay_time.mm
          ? vm.wordafter.follow_up_cart.delay_time.mm
          : '00'
      }
      if (vm.wordafter.follow_up_order.delay_time) {
        vm.wordafter.follow_up_order_within_seconds = {
          HH: '00',
          mm: '00'
        }
        vm.wordafter.follow_up_order_within_seconds.HH = vm.wordafter.follow_up_order.delay_time.HH
          ? vm.wordafter.follow_up_order.delay_time.HH
          : '00'
        vm.wordafter.follow_up_order_within_seconds.mm = vm.wordafter.follow_up_order.delay_time.mm
          ? vm.wordafter.follow_up_order.delay_time.mm
          : '00'
      }

      let data = {
        // buttons_cart_summary: JSON.stringify(vm.wordafter.buttons_cart_summary),
        wordscartsummary: JSON.stringify(vm.wordafter.wordscartsummary),
        wordsorders: JSON.stringify(vm.wordafter.wordsorders),
        pageid: vm.selectedBot.pageid,
        follow_up_cart_quick_reply: vm.wordafter.follow_up_cart.quick_reply
          ? vm.wordafter.follow_up_cart.quick_reply.map((el) => el.text).join(',')
          : '',
        follow_up_order_quick_reply: vm.wordafter.follow_up_order.quick_reply
          ? vm.wordafter.follow_up_order.quick_reply.map((el) => el.text).join(',')
          : '',
        follow_up_cart_status: vm.wordafter.follow_up_cart.status,
        follow_up_order_status: vm.wordafter.follow_up_order.status,
        follow_up_cart_within_seconds: vm.wordafter.follow_up_cart_within_seconds
          ? (parseInt(vm.wordafter.follow_up_cart_within_seconds.HH) * 60 +
              parseInt(
                vm.wordafter.follow_up_cart_within_seconds.mm.substring(0, 1) == 0
                  ? vm.wordafter.follow_up_cart_within_seconds.mm.substring(1)
                  : vm.wordafter.follow_up_cart_within_seconds.mm
              )) *
            60
          : null,
        follow_up_order_within_seconds: vm.wordafter.follow_up_order_within_seconds
          ? (parseInt(vm.wordafter.follow_up_order_within_seconds.HH) * 60 +
              parseInt(
                vm.wordafter.follow_up_order_within_seconds.mm.substring(0, 1) == 0
                  ? vm.wordafter.follow_up_order_within_seconds.mm.substring(1)
                  : vm.wordafter.follow_up_order_within_seconds.mm
              )) *
            60
          : null,
        follow_up_cart_val: JSON.stringify(
          vm.checkEmptyMessage(vm.wordafter.follow_up_cart.messages)
        ),
        follow_up_order_val: JSON.stringify(
          vm.checkEmptyMessage(vm.wordafter.follow_up_order.messages)
        ),
        follow_up_cart_type: 'json',
        follow_up_order_type: 'json'
      }

      if (this.showMultipleChannel) {
        data.follow_up_cart_fb_val = JSON.stringify(
          vm.wordafter.follow_up_cart.multiMessages['fb_messages']
        ).replace(/ /gim, ' ')
        data.follow_up_cart_line_val = JSON.stringify(
          vm.wordafter.follow_up_cart.multiMessages['line_messages']
        ).replace(/ /gim, ' ')
        data.follow_up_cart_ig_val = JSON.stringify(
          vm.wordafter.follow_up_cart.multiMessages['ig_messages']
        ).replace(/ /gim, ' ')
        data.follow_up_cart_fb_quick_reply = vm.wordafter.follow_up_cart.multiQuickReply[
          'fb_quick_reply'
        ]
          ? vm.wordafter.follow_up_cart.multiQuickReply['fb_quick_reply']
              .map((el) => el.text)
              .join(',')
          : ''
        data.follow_up_cart_line_quick_reply = vm.wordafter.follow_up_cart.multiQuickReply[
          'line_quick_reply'
        ]
          ? vm.wordafter.follow_up_cart.multiQuickReply['line_quick_reply']
              .map((el) => el.text)
              .join(',')
          : ''
        data.follow_up_cart_ig_quick_reply = vm.wordafter.follow_up_cart.multiQuickReply[
          'ig_quick_reply'
        ]
          ? vm.wordafter.follow_up_cart.multiQuickReply['ig_quick_reply']
              .map((el) => el.text)
              .join(',')
          : ''
      }

      if (this.showMultipleChannelFollowUp) {
        data.follow_up_order_fb_val = JSON.stringify(
          vm.wordafter.follow_up_order.multiMessages['fb_messages2']
        ).replace(/ /gim, ' ')
        data.follow_up_order_line_val = JSON.stringify(
          vm.wordafter.follow_up_order.multiMessages['line_messages2']
        ).replace(/ /gim, ' ')
        data.follow_up_order_ig_val = JSON.stringify(
          vm.wordafter.follow_up_order.multiMessages['ig_messages2']
        ).replace(/ /gim, ' ')
        data.follow_up_order_fb_quick_reply = vm.wordafter.follow_up_order.multiQuickReply[
          'fb_quick_reply'
        ]
          ? vm.wordafter.follow_up_order.multiQuickReply['fb_quick_reply']
              .map((el) => el.text)
              .join(',')
          : ''
        data.follow_up_order_line_quick_reply = vm.wordafter.follow_up_order_.multiQuickReply[
          'ine_quick_reply'
        ]
          ? vm.wordafter.follow_up_order_.multiQuickReply['ine_quick_reply']
              .map((el) => el.text)
              .join(',')
          : ''
        data.follow_up_order_ig_quick_reply = vm.wordafter.follow_up_order.multiQuickReply[
          'ig_quick_reply'
        ]
          ? vm.wordafter.follow_up_order.multiQuickReply['ig_quick_reply']
              .map((el) => el.text)
              .join(',')
          : ''
      }

      vm.$validator.validate().then((result) => {
        if (!result) {
          // do stuff if not valid.
          vm.goToErrorInput()
          return false
        }
        vm.wordafter.loading = true
        api.saveWordAfterOrderAndCartSummary(data, function (error, response) {
          if (error) {
            console.error(error)
            vm.wordafter.loading = false
            return
          }
          vm.cached_wordscartsummary = JSON.stringify(vm.wordafter.wordscartsummary)
          vm.cached_wordsorders = JSON.stringify(vm.wordafter.wordsorders)
          vm.cached_wordafter = JSON.stringify(vm.wordafter)
          vm.wordafter.loading = false
          vm.isEditMessage = false
        })
      })
    },
    getWordAfterOrderAndCartSummary() {
      let vm = this
      var data = {
        pageid: vm.selectedBot.pageid
      }
      vm.wordafter.loading = true
      api.getWordAfterOrderAndCartSummary(data, function (error, response) {
        if (error) {
          console.error(error)
          vm.wordafter.loading = false
          return
        }
        if (response.data) {
          vm.wordafter = {
            ...vm.wordafter,
            ...response.data,
            follow_up_cart: {
              status: response.data.follow_up_cart_status,
              type: response.data.follow_up_cart_type,
              delay_time: null,
              tab: 'all',
              showMultipleChannel: false,
              messages: [[]],
              quick_reply: response.data.follow_up_cart_quick_reply
                ? response.data.follow_up_cart_quick_reply
                    .split(',')
                    .map((el) => ({ text: el, id: Math.floor(Math.random() * 100000) + 1 }))
                : [],
              multiMessages: vm.$store.state.socialChannelOptions.reduce((prev, social) => {
                prev[`${social.value}_messages`] = [[]]
                return prev
              }, {}),
              multiQuickReply: vm.$store.state.socialChannelOptions.reduce((prev, social) => {
                prev[`${social.value}_quick_reply`] = []
                return prev
              }, {})
            },
            follow_up_order: {
              status: response.data.follow_up_order_status,
              type: response.data.follow_up_order_type,
              delay_time: null,
              tab: 'all',
              showMultipleChannel: false,
              messages: [[]],
              quick_reply: response.data.follow_up_order_quick_reply
                ? response.data.follow_up_order_quick_reply
                    .split(',')
                    .map((el) => ({ text: el, id: Math.floor(Math.random() * 100000) + 1 }))
                : [],
              multiMessages: vm.$store.state.socialChannelOptions.reduce((prev, social) => {
                prev[`${social.value}_messages`] = [[]]
                return prev
              }, {}),
              multiQuickReply: vm.$store.state.socialChannelOptions.reduce((prev, social) => {
                prev[`${social.value}_quick_reply`] = []
                return prev
              }, {})
            },
            wordsorders: response.data.wordsorders
              ? JSON.parse(response.data.wordsorders)
              : {
                  type: 'text',
                  text: ''
                },
            wordscartsummary: response.data.wordscartsummary
              ? JSON.parse(response.data.wordscartsummary)
              : {
                  type: 'text',
                  text: ''
                }
          }

          if (typeof vm.wordafter.follow_up_cart_within_seconds !== 'object') {
            vm.wordafter.follow_up_cart_within_seconds = {
              HH: (
                '0' + Math.floor(parseInt(vm.wordafter.follow_up_cart_within_seconds) / 60 / 60)
              ).slice(-2),
              mm: (
                '0' +
                JSON.stringify((parseInt(vm.wordafter.follow_up_cart_within_seconds) / 60) % 60)
              ).slice(-2)
            }
            vm.wordafter.follow_up_cart.delay_time = vm.wordafter.follow_up_cart_within_seconds
          } else {
          }
          if (typeof vm.wordafter.follow_up_order_within_seconds !== 'object') {
            vm.wordafter.follow_up_order_within_seconds = {
              HH: (
                '0' + Math.floor(parseInt(vm.wordafter.follow_up_order_within_seconds) / 60 / 60)
              ).slice(-2),
              mm: (
                '0' +
                JSON.stringify((parseInt(vm.wordafter.follow_up_order_within_seconds) / 60) % 60)
              ).slice(-2)
            }
            vm.wordafter.follow_up_order.delay_time = vm.wordafter.follow_up_order_within_seconds
          } else {
          }

          if (
            vm.wordafter.follow_up_cart_fb_val ||
            vm.wordafter.follow_up_cart_line_val ||
            vm.wordafter.follow_up_cart_ig_val
          ) {
            vm.wordafter.follow_up_cart.tab = 'fb'
            vm.wordafter.follow_up_cart.showMultipleChannel = true
            vm.wordafter.follow_up_cart.multiMessages = {}
            vm.$store.state.socialChannelOptions.forEach((social) => {
              vm.wordafter.follow_up_cart.multiMessages[`${social.value}_messages`] = vm.wordafter[
                `follow_up_cart_${social.value}_val`
              ] || [[]]
            })
          }

          if (
            vm.wordafter.follow_up_order_fb_val ||
            vm.wordafter.follow_up_order_line_val ||
            vm.wordafter.follow_up_order_ig_val
          ) {
            vm.wordafter.follow_up_order.tab = 'fb'
            vm.wordafter.follow_up_order.showMultipleChannel = true
            vm.wordafter.follow_up_order.multiMessages = {}
            vm.$store.state.socialChannelOptions.forEach((social) => {
              vm.wordafter.follow_up_order.multiMessages[`${social.value}_messages`] = vm.wordafter[
                `follow_up_order_${social.value}_val`
              ] || [[]]
            })
          }

          if (response.data.follow_up_cart_val) {
            vm.wordafter.follow_up_cart.messages = JSON.parse(response.data.follow_up_cart_val)
          }
          if (response.data.follow_up_order_val) {
            vm.wordafter.follow_up_order.messages = JSON.parse(response.data.follow_up_order_val)
          }
        }
        vm.cached_wordafter = JSON.stringify(vm.wordafter)

        vm.cached_wordscartsummary = JSON.stringify(vm.wordafter.wordscartsummary)
        vm.cached_wordsorders = JSON.stringify(vm.wordafter.wordsorders)
        vm.wordafter.loading = false
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/PaymentMessageAfterSummary.vue